'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();

import { CalendlyButton } from '@/components/integrations/calendly/calendly-buttons'
import { PlainButtonLink } from '@/components/ui/button'
import { getPagePath, type Locale } from '@/i18n/routing'
import { trackCta } from '@/lib/analytics/track-cta'

/**
 * The "book a demo" + "contact us" CTA pair used by pages that end on demo-or-contact rather
 * than the primary start-trial flow (e.g. About). Mirrors `PrimaryCtaButtons`' structure.
 */
export function BookDemoContactButtons({
  locale,
  bookDemoLabel,
  contactLabel,
  location = 'cta',
}: {
  locale: Locale
  bookDemoLabel: string
  contactLabel: string
  location?: string
}) {
  return (
    <div className="flex items-center gap-4">
      <CalendlyButton label={bookDemoLabel} location={location} />
      <PlainButtonLink href={getPagePath(locale, 'contact')} onClick={() => trackCta(location, contactLabel)}>
        {contactLabel}
      </PlainButtonLink>
    </div>
  )
}
